const ADMIN = 'admin';
const ADMIN_BE = 'admin_be';

const IR_EDIT = 'ir_edit';
const IR_EDIT_CREATE_REQUEST = 'ir_edit_create_request';
const IR_EDIT_EDIT = 'ir_edit_edit';
const IR_EDIT_DUPLICATE = 'ir_edit_duplicate';
const IR_EDIT_DELETE = 'ir_edit_delete';

const IR_ERUL = 'ir_ERUL';
const IR_ELK_EPGU = 'ir_elk_epgu';
const IR_EAES = 'ir_eaes';

const IR_EDIT_FEED_CREATE_REQUEST = 'ir_edit_feed_create_request';
const IR_EDIT_FEED_EDIT = 'ir_edit_feed_edit';
const IR_EDIT_FEED_DUPLICATE = 'ir_edit_feed_duplicate';
const IR_EDIT_FEED_DELETE = 'ir_edit_feed_delete';

const IR_EDIT_GMO_CREATE_REQUEST = 'ir_edit_gmo_create_request';
const IR_EDIT_GMO_EDIT = 'ir_edit_gmo_edit';
const IR_EDIT_GMO_DUPLICATE = 'ir_edit_gmo_duplicate';
const IR_EDIT_GMO_DELETE = 'ir_edit_gmo_delete';

const IR_EDIT_GP_CREATE_REQUEST = 'ir_edit_gp_create_request';
const IR_EDIT_GP_EDIT = 'ir_edit_gp_edit';
const IR_EDIT_GP_DUPLICATE = 'ir_edit_gp_duplicate';
const IR_EDIT_GP_DELETE = 'ir_edit_gp_delete';

const IR_EDIT_SUBST_CREATE_REQUEST = 'ir_edit_subst_create_request';
const IR_EDIT_PH_CREATE_REQUEST = 'ir_edit_ph_create_request';

const IR_V = 'ir_v';
const IR_V_PRINT = 'ir_v_print';
const IR_V_FEED_PRINT = 'ir_v_feed_print';
const IR_V_GMO_PRINT = 'ir_v_gmo_print';
const IR_V_GP_PRINT = 'ir_v_gp_print';

const INSTRUCTIONS = 'instructions';
const INSTRUCTIONS_VGNKI = 'instructions_vgnki';
const INSTRUCTIONS_PATENTEE = 'instructions_patentee';
const INSTRUCTIONS_APOTHECARY = 'instructions_apothecary';
const INSTRUCTIONS_VETERINARIAN = 'instructions_veterinarian';
const INSTRUCTIONS_CENTRAL_APPARAT = 'instructions_central_apparat';
const INSTRUCTIONS_ADMIN_BE = 'instructions_admin_be';

const CAT = 'cat';
const CAT_VIEW = 'cat_view';
const CAT_EDIT = 'cat_edit';
const CAT_EDIT_BE = 'cat_edit_be';

const G_V = 'g_v';
const G_V_OWN = 'g_v_own';
const G_V_OWN_PH = 'g_v_own_ph';
const G_V_OWN_REPORT = 'g_v_own_report';
const G_V_PH_REPORT = 'g_v_ph_report';
const G_V_REG_REQUEST = 'g_v_reg_request';
const G_V_PH_REQUEST = 'g_v_ph_request';
const G_V_CONSIGNMENT = 'g_v_consignment';

const PATENTEE_PHARM_SUPPLIER_LIST = 'patentee_pharm_supplier_list';
const RSHSN_PHARM_SUPPLIER_LIST = 'rshsn_pharm_supplier_list';

const PATENTEE_PHARM_PERM = 'patentee_pharm_perm';
const RSHSN_PHARM_PERM = 'rshsn_pharm_perm';

const PATENTEE_CONSIGNMENT = 'patentee_consignment';
const RSHSN_CONSIGNMENT = 'rshsn_consignment';

const RSHSN_GMP_COMPLIANCE_CONCLUSION = 'rshsn_gmp_compliance_conclusion';
const RSHSN_DPO = 'rshsn_dpo';

const REACTION_STATEMENT = 'reaction_statement';
const REACTION_STATEMENT_EDIT = 'reaction_statement_edit';
const REACTION_STATEMENT_VIEW = 'reaction_statement_view';
const REACTION_STATEMENT_PROLONGATION = 'reaction_statement_prolongation';
const REACTION_STATEMENT_EXCEL = 'reaction_statement_excel';
const REACTION_STATEMENT_REVIEW = 'reaction_statement_review';
const REACTION_STATEMENT_MEASURE = 'reaction_statement_measure';
const REACTION_STATEMENT_CONCLUSION = 'reaction_statement_conclusion';

const PRESCRIPTION = 'prescription';
const PRESCRIPTION_VIEW = 'prescription_view';
const PRESCRIPTION_EXCEL = 'prescription_excel';
const PRESCRIPTION_CREATE = 'prescription_create';
const PRESCRIPTION_EDIT = 'prescription_edit';
const PRESCRIPTION_USAGE = 'prescription_usage';
const PRESCRIPTION_PAPER = 'prescription_paper';

const INSPECTOR = 'inspector';
const INSPECTOR_VIEW = 'inspector_view';
const INSPECTOR_EDIT = 'inspector_edit';

const FAKE = 'fake';
const FAKE_EDIT = 'fake_edit';
const FAKE_VIEW = 'fake_view';

const IR_BE_CERBER = 'ir_be_cerber';

const IR_LK_REC = 'ir_lk_rec';

export const ROLES = {
  requestMotionStatuses: [IR_EDIT],
  feedAdditiveCard: {
    create: [IR_EDIT, IR_EDIT_CREATE_REQUEST, IR_EDIT_FEED_CREATE_REQUEST],
    edit: [IR_EDIT, IR_EDIT_EDIT, IR_EDIT_FEED_EDIT],
    duplicate: [IR_EDIT, IR_EDIT_DUPLICATE, IR_EDIT_FEED_DUPLICATE],
    remove: [IR_EDIT, IR_EDIT_DELETE, IR_EDIT_FEED_DELETE],
    print: [IR_V, IR_V_PRINT, IR_V_FEED_PRINT],
  },
  gmo: {
    create: [IR_EDIT, IR_EDIT_CREATE_REQUEST, IR_EDIT_GMO_CREATE_REQUEST],
    edit: [IR_EDIT, IR_EDIT_EDIT, IR_EDIT_GMO_EDIT],
    duplicate: [IR_EDIT, IR_EDIT_DUPLICATE, IR_EDIT_GMO_DUPLICATE],
    remove: [IR_EDIT, IR_EDIT_DELETE, IR_EDIT_GMO_DELETE],
    print: [IR_V, IR_V_PRINT, IR_V_GMO_PRINT],
  },
  gmProduct: {
    create: [IR_EDIT, IR_EDIT_CREATE_REQUEST, IR_EDIT_GP_CREATE_REQUEST],
    edit: [IR_EDIT, IR_EDIT_EDIT, IR_EDIT_GP_EDIT],
    duplicate: [IR_EDIT, IR_EDIT_DUPLICATE, IR_EDIT_GP_DUPLICATE],
    remove: [IR_EDIT, IR_EDIT_DELETE, IR_EDIT_GP_DELETE],
    print: [IR_V, IR_V_PRINT, IR_V_GP_PRINT],
  },
  substanceCard: {
    create: [IR_EDIT, IR_EDIT_CREATE_REQUEST, IR_EDIT_SUBST_CREATE_REQUEST],
  },
  pharmCard: {
    create: [IR_EDIT, IR_EDIT_CREATE_REQUEST, IR_EDIT_PH_CREATE_REQUEST],
  },
  catalogs: [CAT, CAT_VIEW, CAT_EDIT, CAT_EDIT_BE],
  monitoringLp: {
    pharm: [G_V_OWN, G_V_OWN_PH],
    reports: [G_V_OWN, G_V_OWN_REPORT],
    sentReports: [G_V, G_V_PH_REPORT],
    requests: [G_V, G_V_REG_REQUEST, ADMIN],
    modifyListRequests: [G_V, G_V_PH_REQUEST],
  },
  supplierLp: {
    rshsn: [RSHSN_PHARM_SUPPLIER_LIST],
    patentee: [PATENTEE_PHARM_SUPPLIER_LIST],
  },
  gmp: {
    interact: [RSHSN_GMP_COMPLIANCE_CONCLUSION],
    downloadErul: [IR_ERUL],
  },
  permits: [PATENTEE_PHARM_PERM, RSHSN_PHARM_PERM],
  consignments: {
    add: [PATENTEE_CONSIGNMENT],
    registry: [PATENTEE_CONSIGNMENT, RSHSN_CONSIGNMENT, G_V_CONSIGNMENT],
    argus: [RSHSN_CONSIGNMENT],
    patentee: [PATENTEE_CONSIGNMENT],
    rshsn: [RSHSN_CONSIGNMENT],
  },
  instructions: {
    VGNKI: [INSTRUCTIONS, INSTRUCTIONS_VGNKI],
    PATENTEE: [INSTRUCTIONS, INSTRUCTIONS_PATENTEE],
    APOTHECARY: [INSTRUCTIONS, INSTRUCTIONS_APOTHECARY],
    VETERINARIAN: [INSTRUCTIONS, INSTRUCTIONS_VETERINARIAN],
    CENTRAL_APPARAT: [INSTRUCTIONS, INSTRUCTIONS_CENTRAL_APPARAT],
    ADMIN_BE: [INSTRUCTIONS, INSTRUCTIONS_ADMIN_BE],
  },
  adversePetitions: {
    edit: [REACTION_STATEMENT, REACTION_STATEMENT_EDIT],
    view: [REACTION_STATEMENT, REACTION_STATEMENT_VIEW],
    prolongation: [REACTION_STATEMENT, REACTION_STATEMENT_PROLONGATION],
    excel: [REACTION_STATEMENT, REACTION_STATEMENT_EXCEL],
    review: [REACTION_STATEMENT, REACTION_STATEMENT_REVIEW],
    measure: [REACTION_STATEMENT, REACTION_STATEMENT_MEASURE],
    conclusion: [REACTION_STATEMENT, REACTION_STATEMENT_CONCLUSION],
    any: [
      REACTION_STATEMENT,
      REACTION_STATEMENT_EDIT,
      REACTION_STATEMENT_VIEW,
      REACTION_STATEMENT_PROLONGATION,
      REACTION_STATEMENT_EXCEL,
      REACTION_STATEMENT_REVIEW,
      REACTION_STATEMENT_MEASURE,
      REACTION_STATEMENT_CONCLUSION,
    ],
  },
  inspectors: {
    edit: [INSPECTOR, INSPECTOR_EDIT],
    view: [INSPECTOR, INSPECTOR_VIEW],
  },
  prescription: {
    view: [PRESCRIPTION, PRESCRIPTION_VIEW],
    edit: [PRESCRIPTION, PRESCRIPTION_EDIT],
    excel: [PRESCRIPTION, PRESCRIPTION_EXCEL],
    create: [PRESCRIPTION, PRESCRIPTION_CREATE],
    usage: [PRESCRIPTION, PRESCRIPTION_USAGE],
    paper: [PRESCRIPTION, PRESCRIPTION_PAPER],
  },
  dpo: {
    create: [RSHSN_DPO],
  },
  fakes: {
    view: [FAKE, FAKE_VIEW],
    edit: [FAKE, FAKE_EDIT],
  },
  admin: [ADMIN],
  adminBe: [ADMIN_BE],
  requestMotionEdit: [IR_EDIT_FEED_EDIT],
  patenteePharmPerm: [PATENTEE_PHARM_PERM],
  rshsnPharmPerm: [RSHSN_PHARM_PERM],
  catalogsEdit: [ADMIN, CAT, CAT_EDIT],
  erul: [IR_ERUL],
  elk: [IR_ELK_EPGU],
  eaes: [IR_EAES],
  cerberus: [IR_BE_CERBER],
  lkRec: [IR_LK_REC],
};
